type ApiOptions = Omit<RequestInit, 'body'> & { body?: unknown }

export async function api<T>(path: string, options: ApiOptions = {}): Promise<T> {
  const response = await fetch(`/api${path}`, {
    ...options,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options.headers },
    body: options.body === undefined ? undefined : JSON.stringify(options.body),
  })
  const payload = await response.json().catch(() => ({})) as { error?: string }
  if (!response.ok) throw new Error(payload.error || 'Não foi possível concluir a solicitação.')
  return payload as T
}

export function formatDate(value?: string) {
  if (!value) return '—'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? '—' : new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short', timeZone: 'America/Sao_Paulo' }).format(date)
}

export const brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
export const integer = new Intl.NumberFormat('pt-BR')

export function downloadCsv(filename: string, rows: Record<string, unknown>[]) {
  if (!rows.length) throw new Error('Não há dados para exportar.')
  const fields = Array.from(new Set(rows.flatMap(row => Object.keys(row))))
  const quote = (value: unknown) => `"${String(value ?? '').replace(/"/g, '""')}"`
  const contents = '\ufeff' + [fields.map(quote).join(';'), ...rows.map(row => fields.map(field => quote(row[field])).join(';'))].join('\n')
  const url = URL.createObjectURL(new Blob([contents], { type: 'text/csv;charset=utf-8' }))
  const anchor = document.createElement('a')
  anchor.href = url; anchor.download = filename; anchor.click()
  URL.revokeObjectURL(url)
}
